(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../hmodules/components/h-charts/partials/chart-donut.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"radius");
frame.set("radius", t_1, true);
if(frame.topLevel) {
context.setVariable("radius", t_1);
}
if(frame.topLevel) {
context.addExport("radius", t_1);
}
output += " ";
var t_2;
t_2 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"innerRadius");
frame.set("innerRadius", t_2, true);
if(frame.topLevel) {
context.setVariable("innerRadius", t_2);
}
if(frame.topLevel) {
context.addExport("innerRadius", t_2);
}
output += " ";
var t_3;
t_3 = ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortWidth") - runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength")) / 2);
frame.set("xOffset", t_3, true);
if(frame.topLevel) {
context.setVariable("xOffset", t_3);
}
if(frame.topLevel) {
context.addExport("xOffset", t_3);
}
output += " ";
var t_4;
t_4 = ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortHeight") - runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength")) / 2);
frame.set("yOffset", t_4, true);
if(frame.topLevel) {
context.setVariable("yOffset", t_4);
}
if(frame.topLevel) {
context.addExport("yOffset", t_4);
}
output += " <svg height=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength") / runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortHeight")) * 100, env.opts.autoescape);
output += "%\" class=\"pie-chart\" width=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength") / runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewPortWidth")) * 100, env.opts.autoescape);
output += "%\" viewBox=\"0 0 ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength"), env.opts.autoescape);
output += "\" x=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "xOffset"), env.opts.autoescape);
output += "\" y=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "yOffset"), env.opts.autoescape);
output += "\"> ";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"donuts");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("donut", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += " ";
if(runtime.memberLookup((t_8),"radius")) {
output += " ";
var t_9;
t_9 = runtime.memberLookup((t_8),"radius");
frame.set("radius", t_9, true);
if(frame.topLevel) {
context.setVariable("radius", t_9);
}
if(frame.topLevel) {
context.addExport("radius", t_9);
}
output += " ";
;
}
output += " ";
if(runtime.memberLookup((t_8),"innerRadius")) {
output += " ";
var t_10;
t_10 = runtime.memberLookup((t_8),"innerRadius");
frame.set("innerRadius", t_10, true);
if(frame.topLevel) {
context.setVariable("innerRadius", t_10);
}
if(frame.topLevel) {
context.addExport("innerRadius", t_10);
}
output += " ";
;
}
output += " ";
frame = frame.push();
var t_13 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"values")),0)),"v");
if(t_13) {t_13 = runtime.fromIterator(t_13);
var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("donutSlice", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += " ";
if(runtime.memberLookup((t_14),"value")) {
output += " ";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.memberLookup((runtime.memberLookup((t_8),"code")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")));
frame.set("valueMap", t_15, true);
if(frame.topLevel) {
context.setVariable("valueMap", t_15);
}
if(frame.topLevel) {
context.addExport("valueMap", t_15);
}
output += " ";
if((runtime.memberLookup((t_14),"value") / runtime.memberLookup((t_8),"total")) == 1) {
output += " <circle stroke=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "valueMap")),"color"), env.opts.autoescape);
output += "\" stroke-width=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "radius") - runtime.contextOrFrameLookup(context, frame, "innerRadius"), env.opts.autoescape);
output += "\" fill=\"transparent\" r=\"";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "radius") + runtime.contextOrFrameLookup(context, frame, "innerRadius")) / 2, env.opts.autoescape);
output += "\" cx=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength") / 2, env.opts.autoescape);
output += "\" cy=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"squareSideLength") / 2, env.opts.autoescape);
output += "\"/> ";
;
}
else {
output += " <path fill=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "valueMap")),"color"), env.opts.autoescape);
output += "\" class=\"donut-chart-slice\" d=\"M ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"innerStartPosition")),"x"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"innerStartPosition")),"y"), env.opts.autoescape);
output += " L ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"outerStartPosition")),"x"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"outerStartPosition")),"y"), env.opts.autoescape);
output += " A ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "radius"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "radius"), env.opts.autoescape);
output += " 0 ";
output += runtime.suppressValue(runtime.memberLookup((t_14),"largeArcFlag"), env.opts.autoescape);
output += " 1 ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"outerEndPosition")),"x"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"outerEndPosition")),"y"), env.opts.autoescape);
output += " L ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"innerEndPosition")),"x"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"innerEndPosition")),"y"), env.opts.autoescape);
output += " A ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "innerRadius"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "innerRadius"), env.opts.autoescape);
output += " 0 ";
output += runtime.suppressValue(runtime.memberLookup((t_14),"largeArcFlag"), env.opts.autoescape);
output += " 0 ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"innerStartPosition")),"x"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_14),"innerStartPosition")),"y"), env.opts.autoescape);
output += "\"> </path> ";
;
}
output += " ";
;
}
output += " ";
;
}
}
frame = frame.pop();
output += " ";
;
}
}
frame = frame.pop();
output += " </svg>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
